/**
 * Build the canonical public URL for a venue.
 *
 * Format: /venue/{district_slug}/{area_slug}/{venue_slug}
 *
 * Accepts either a "venue" shape (`{slug, district_slug, area_slug}`) OR a
 * booking shape (`{venue_slug, district_slug, area_slug}`) so callers don't
 * have to remap fields. Falls back to "no-area" when a venue has no Area
 * assigned, and to "unknown" for missing district — keeps the URL valid even
 * on partial data during the migration window. The backend's path lookup
 * will still resolve the venue as long as the slug is correct.
 */
export function venueUrl(venue) {
  if (!venue) return "/venues";
  const district =
    venue.district_slug ||
    venue.city_slug ||
    (venue.district_id || venue.city_id || "unknown")
      .toString()
      .toLowerCase()
      .replace(/^city_/, "");
  const area = venue.area_slug || "no-area";
  const slug = venue.slug || venue.venue_slug || "";
  if (!slug) return "/venues";
  return `/venue/${district}/${area}/${slug}`;
}
